<template>
    <div>    
        <section class="page-section bg-light" id="listen">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-left">
                        <a href="https://open.spotify.com/album/00XMFlHLTxBTx3nD6LwVZa?si=YS-9qvFGTLaCZJRnVpqZ1g&dl_branch=1"><img src="/img/article2.jpeg" class="rounded mx-auto d-block mr-2 mb-3"/></a>
                        <hr>
                        <div class="mb-4">
                            <h2 class="mt-0 mb-0">
                                <b>If I Had the Words</b> by Jesse
                            </h2>
                            <p class="mb-1 text-muted text-sm">Follow Jesse</p>
                            <a target="_blank" href="https://linktr.ee/jesseiguess">
                                <img class="mr-2" src="img/linktree.png" height="25px" />
                            </a>
                            <a target="_blank"  href="https://open.spotify.com/album/00XMFlHLTxBTx3nD6LwVZa?si=YS-9qvFGTLaCZJRnVpqZ1g&dl_branch=1">
                                <img class="mr-2" src="img/spotify.svg" height="25px" />
                            </a>
                            <a target="_blank"  href="https://www.youtube.com/channel/UC5viCDALgZXoC3SYYzxEb9g">
                                <img class="mr-2" src="img/yt.png" height="25px" />
                            </a>
                            <a target="_blank"  href="https://www.instagram.com/jesseiguess/">
                                <img class="mr-2" src="img/ig.png" height="25px" />
                            </a>
                        </div>
                        <p>
                            Jessica "Jesse" Franklin is a local singer/songwriter from Minneapolis, MN who had long been working on her first album. After several attempts to work with various producers, she finally connected with Chris Smith, a musician and world-class bassist from south Minneapolis. He reached out to Raj Maitra of Loonatic Productions to realize Jesse's first album. Together they arranged and brought to light the balladic vision of Jesse's first album <b>If I had the Words</b>.   
                         </p> 
                         <p>
                             The project took the summer of 2020 to finish and was produced by Raj Maitra (of Loonatic Productions) and Chris Smith <a target="_blank" href="https://www.instagram.com/cee.smith/">(Chris Smith Instagram)</a>.
                             
                          </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-0 mt-4">
                        <h3><b>Music Videos</b></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 text-left"  v-for="item in items" v-bind:key="item.id">
                        <div class="mt-5">
                            <h3 class="h4 mb-2">
                                <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                    {{ item.title }}
                                </a>
                            </h3>
                        </div>
                        <div class="mt-2">
                            <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                <img v-bind:src="'http://img.youtube.com/vi/'+ item.id + '/0.jpg'" async class="rounded w-90 shadow play-youtube-video lazy ">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        

    </div>
</template>

<script>
export default {
    name: 'Article1',
    components: {
    },
    data: function(){
        return{
            items: [
                { 
                    title: 'Shelter',  
                    id:'ltiZWM04Jjg'
                },
                { 
                    title: 'Damaged',  
                    id:'Xz7i_AI-fu8'
                },
                {
                    title:'Make You Feel My Love (Cover by Jesse)',
                    id:'0i1M8OMjVJg'
                },
                {
                    title:'Mistakes (Cover by Jesse)',
                    id:'Fjt8nhxORYs'
                }
            ]
        }
    }
}
</script>